import ClientService from '../../../services/client-service';
import getDealTemplateListDataQuery from '../../../graphql/query/get-deal-template-list-data.graphql';
import saveDealTemplateListDataMutation from '../../../graphql/mutation/save-deal-template-list-data.graphql';
import deleteDealTemplateMutation from '../../../graphql/mutation/delete-deal-template.graphql';

export default class SettingsDealTemplateListApi {
  public static getDealTemplateListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealTemplateListDataQuery, payload);
  }

  public static saveDealTemplateListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(saveDealTemplateListDataMutation, payload);
  }

  public static deleteDealTemplate(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(deleteDealTemplateMutation, payload);
  }
}
